import styled, { css } from 'styled-components'

export const Container = styled.div`
  /* Container dentro do modal pai: usar posicionamento estático/relativo
     para garantir que o conteúdo não escape dos limites do modal. */
  position: relative;
  width: 31vw;
  max-width: 720px;
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  box-sizing: border-box;
  padding: 2.2vh 1.5vw 2.5vh 1.5vw;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 0 1vh 0;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const SubText = styled.p`
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 400;
  margin: 0 0 1vh 0;
`

export const ListItem = styled.li`
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0.4vh;
`

export const SuccessText = styled.span`
  color: green;
`

export const ErrorText = styled.span`
  color: red;
`

export const ProgressContainer = styled.div`
  height: 18px;
  background-color: grey;
  margin: 1.2vh 0 2vh 0;
  width: 100%;
  max-width: 100%;
  border-radius: 2vw;
`

export const ProgressFill = styled.div`
  height: 18px;
  background-color: #6ec1e4;
  border-radius: 2vw;
`

export const ButtonsDiv = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  margin-top: 2vh;
`

export const FinishButton = styled.button`
  width: 8vw;
  min-width: 96px;
  height: 5.2vh;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 0;
  border: 1px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;
`

export const DisabledFinishButton = styled.button`
  width: 8vw;
  min-width: 96px;
  height: 5.2vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 0;
  border: 0;
  border-radius: 3vw;
  cursor: not-allowed;
`
